import { MessageCircle } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import { useSettings } from "../context/SettingsContext";

export default function Layout({ children }) {
  const { whatsappLink } = useSettings();

  return (
    <>
      <Header />
      {children}
      <a
        className="whatsapp-float"
        href={whatsappLink("Hi Lalita Soujanya, I would like to enquire.")}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={22} />
      </a>
      <Footer />
    </>
  );
}
